import { DEFAULT_CURRENCY } from '@/lib/currency.constants'

export function toCurrency({
  value,
  isCents = false,
  currency = DEFAULT_CURRENCY,
  locale = 'en-US',
  showCurrency = true,
}: {
  value: number
  currency?: string
  locale?: string
  isCents?: boolean
  showCurrency?: boolean
}): string {
  if (value === null) return ''

  const amount = isCents ? value / 100 : value

  const formatted = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)

  return showCurrency ? `$${formatted} ${currency}` : `$${formatted}`
}
